const appearStoreId = (id, value) => `${id}: ${value}`;

export { appearStoreId };
